export const profile = {
  extends: 'Page',
  flow: 'y',
  theme: 'document',

  LawyersData: {
    fetch: {
      from: 'lawyers',
      cache: '5m',
      keepPreviousData: true,
      params: () => {
        const params = new URLSearchParams(window.location.search)
        const slug = params.get('slug')
        if (slug) {
          const match = slug.match(/-([A-Z][\w-]*)$/)
          if (match) return { bar_id: match[1] }
        }
        const id = params.get('id')
        if (id) return { id }
      },
      transform: (data, el) => {
        const lawyers = (data || []).map(d => el.call('mapLawyer', d))
        const root = el.state.root || el.state
        if (root && root.update) root.update({ lawyers, lawyersLoaded: true }, { preventFetch: true })
        return lawyers
      }
    },
    display: 'none'
  },
  FirmsData: {
    fetch: {
      from: 'law_firms',
      order: { by: 'name_en', asc: true },
      limit: 50,
      cache: '5m',
      keepPreviousData: true,
      transform: (data, el) => {
        const firms = (data || []).map(d => el.call('mapFirm', d))
        const root = el.state.root || el.state
        if (root && root.update) root.update({ firms, firmsLoaded: true }, { preventFetch: true })
        return firms
      }
    },
    display: 'none'
  },

  LandingNav: {},

  ProfileDetail: {
    flow: 'y',
    gap: 'A',
    padding: 'F B B B',
    width: '100%',
    maxWidth: 'K',
    margin: '0 auto',
    flex: '1',
    '@mobileL': { padding: 'E A A A' },

    BackRow: {
      extends: 'Link',
      href: '/lawyers',
      text: '{{ backToDirectory | polyglot }}',
      fontSize: 'Z',
      opacity: '0.7',
      textDecoration: 'none',
      fontWeight: '500',
      marginBottom: 'Y',
      ':hover': { opacity: '1' }
    },

    MainLayout: {
      flow: 'x',
      gap: 'B',
      width: '100%',
      align: 'stretch flex-start',
      '@mobileL': { flow: 'y' },

      LeftCol: {
        flex: '1',
        flow: 'y',
        gap: 'A',
        minWidth: '0',

        // === HEADER CARD ===
        HeaderCard: {
          flow: 'y',
          gap: 'A',
          padding: 'B',
          round: 'A',
          theme: 'card',

          TopRow: {
            flow: 'x',
            gap: 'A',
            align: 'flex-start flex-start',
            '@mobileL': { flow: 'y' },

            Avatar: {
              tag: 'img',
              width: 'E',
              height: 'E',
              round: (el, s) => el.call('isFirmPage') ? 'Z' : 'E',
              flexShrink: '0',
              objectFit: 'cover',
              src: (el, s) => {
                const e = el.call('getEntity')
                return e ? (e.photoUrl || e.avatar || e.logo || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(e.nameEn) + '&background=1a2332&color=c6ac8f&size=128&bold=true&format=svg') : ''
              }
            },

            Info: {
              flow: 'y',
              gap: 'Y',
              flex: '1',

              NameRow: {
                flow: 'x',
                align: 'center space-between',
                flexWrap: 'wrap',
                gap: 'Y',
                Name: {
                  tag: 'h1',
                  text: (el, s) => { const e = el.call('getEntity'); return e ? e.nameEn : 'Not found' },
                  fontSize: 'C',
                  fontWeight: '700',
                  letterSpacing: '-0.02em'
                },
                StatusBadge: {
                  show: (el, s) => !el.call('isFirmPage'),
                  text: (el, s) => { const e = el.call('getEntity'); return e ? e.status : '' },
                  padding: 'W Z',
                  round: 'Y',
                  fontSize: 'Y',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  theme: (el, s) => { const e = el.call('getEntity'); return e && e.status === 'active' ? 'success' : 'danger' }
                }
              },

              NameKa: {
                text: (el, s) => { const e = el.call('getEntity'); return e ? e.nameKa : '' },
                fontSize: 'A',
                opacity: '0.6'
              },

              // Lawyer: Bar ID
              BarIdRow: {
                show: (el, s) => !el.call('isFirmPage'),
                flow: 'x', gap: 'Y', align: 'center flex-start',
                BarLabel: { text: '{{ barId | polyglot }}:', fontSize: 'Z', opacity: '0.5' },
                BarVal: { text: (el, s) => { const e = el.call('getEntity'); return e ? e.barId : '' }, fontSize: 'Z', fontWeight: '600' }
              },

              // Lawyer: Firm affiliation
              FirmLink: {
                show: (el, s) => !el.call('isFirmPage'),
                extends: 'Link',
                href: (el, s) => { const e = el.call('getEntity'); if (!e || !e.firmId) return '#'; const f = el.call('getFirmForEntity', e.firmId); return f ? '/firm?slug=' + f.slug : '#' },
                text: (el, s) => {
                  const e = el.call('getEntity')
                  if (!e) return ''
                  if (e.firmId) { const f = el.call('getFirmForEntity', e.firmId); return f ? f.nameEn : '' }
                  return '{{ independent | polyglot }}'
                },
                fontSize: 'Z', color: 'green', fontWeight: '500', textDecoration: 'none',
                ':hover': { textDecoration: 'underline' }
              },

              // Firm: Address
              AddressRow: {
                show: (el, s) => el.call('isFirmPage'),
                flow: 'x', gap: 'W', align: 'center flex-start',
                PinIcon: { extends: 'Icon', icon: 'mapPin', width: 'Z', height: 'Z', opacity: '0.5' },
                AddrText: { text: (el, s) => { const e = el.call('getEntity'); return e ? e.address : '' }, fontSize: 'Z', opacity: '0.7' }
              },

              // Contact row (shared)
              ContactRow: {
                flow: 'x', gap: 'A', align: 'center flex-start', flexWrap: 'wrap',
                PhoneLink: {
                  if: (el, s) => { const e = el.call('getEntity'); return e && e.phone },
                  extends: 'Link',
                  href: (el, s) => { const e = el.call('getEntity'); return e && e.phone ? 'tel:' + e.phone.replace(/\s/g, '') : '#' },
                  textDecoration: 'none', flow: 'x', gap: 'W', align: 'center flex-start',
                  PhoneIcon: { extends: 'Icon', icon: 'phone', width: 'Z', height: 'Z', opacity: '0.5' },
                  PhoneText: { text: (el, s) => { const e = el.call('getEntity'); return e ? e.phone : '' }, fontSize: 'Z', color: 'green', fontWeight: '500' }
                },
                EmailLink: {
                  if: (el, s) => { const e = el.call('getEntity'); return e && e.email },
                  extends: 'Link',
                  href: (el, s) => { const e = el.call('getEntity'); return e && e.email ? 'mailto:' + e.email : '#' },
                  textDecoration: 'none', flow: 'x', gap: 'W', align: 'center flex-start',
                  EmailIcon: { extends: 'Icon', icon: 'mail', width: 'Z', height: 'Z', opacity: '0.5' },
                  EmailText: { text: (el, s) => { const e = el.call('getEntity'); return e ? e.email : '' }, fontSize: 'Z', color: 'green', fontWeight: '500' }
                },
                WebLink: {
                  if: (el, s) => { const e = el.call('getEntity'); return e && e.website },
                  extends: 'Link',
                  href: (el, s) => { const e = el.call('getEntity'); return e ? e.website : '#' },
                  attr: { target: '_blank' },
                  textDecoration: 'none', flow: 'x', gap: 'W', align: 'center flex-start',
                  WebIcon: { extends: 'Icon', icon: 'externalLink', width: 'Z', height: 'Z', opacity: '0.5' },
                  WebText: { text: '{{ website | polyglot }}', fontSize: 'Z', color: 'green', fontWeight: '500' }
                },
                CityInfo: {
                  flow: 'x', gap: 'W', align: 'center flex-start',
                  CityIcon: { extends: 'Icon', icon: 'mapPin', width: 'Z', height: 'Z', opacity: '0.5' },
                  CityText: { text: (el, s) => { const e = el.call('getEntity'); return e ? e.city : '' }, fontSize: 'Z', opacity: '0.6' }
                }
              }
            }
          },

          // Tags (shared — specializations or practiceAreas)
          Tags: {
            flow: 'x', gap: 'Y', flexWrap: 'wrap', marginTop: 'Y',
            children: (el, s) => {
              const e = el.call('getEntity')
              if (!e) return []
              const tags = el.call('isFirmPage') ? (e.practiceAreas || []) : (e.specializations || [])
              return tags.map(t => ({ label: t }))
            },
            childrenAs: 'state',
            childProps: { text: (el, s) => s.label, padding: 'W Z', round: 'C', fontSize: 'Y', fontWeight: '500', theme: 'secondary' }
          },

          // Lawyer: Rating / Experience / Languages
          MetaRow: {
            show: (el, s) => !el.call('isFirmPage'),
            flow: 'x', gap: 'A', flexWrap: 'wrap', marginTop: 'Z',
            RatingInfo: {
              flow: 'x', gap: 'W', align: 'center flex-start',
              Star: { text: '\u2605', color: 'green' },
              RatingVal: { text: (el, s) => { const e = el.call('getEntity'); return e ? e.rating + ' (' + e.reviews + ' {{ reviews | polyglot }})' : '' }, fontSize: 'Z' }
            },
            ExpInfo: {
              text: (el, s) => {
                const e = el.call('getEntity')
                if (!e || !e.admissionDate) return ''
                const years = new Date().getFullYear() - new Date(e.admissionDate).getFullYear()
                return years + ' {{ yearsExperience | polyglot }}'
              },
              fontSize: 'Z', opacity: '0.6'
            },
            LangInfo: {
              text: (el, s) => {
                const e = el.call('getEntity')
                if (!e || !e.languages) return ''
                const langMap = { ka: 'Georgian', en: 'English', ru: 'Russian', de: 'German', fr: 'French', tr: 'Turkish' }
                return '{{ languages | polyglot }}: ' + e.languages.map(x => langMap[x] || x).join(', ')
              },
              fontSize: 'Z', opacity: '0.6'
            }
          },

          // Firm: Year + City meta
          FirmMeta: {
            show: (el, s) => el.call('isFirmPage'),
            flow: 'x', gap: 'A', marginTop: 'Y',
            YearBadge: {
              show: (el, s) => { const e = el.call('getEntity'); return e && e.foundedYear },
              text: (el, s) => { const e = el.call('getEntity'); return e ? 'Est. ' + e.foundedYear : '' },
              fontSize: 'Y', opacity: '0.5'
            },
            CityBadge: {
              text: (el, s) => { const e = el.call('getEntity'); return e ? e.city : '' },
              fontSize: 'Y', padding: 'V Y', round: 'C', theme: 'secondary'
            }
          }
        },

        // === ABOUT / BIO (shared) ===
        AboutCard: {
          show: (el, s) => {
            const e = el.call('getEntity')
            return e && (e.bioEn || e.descriptionEn)
          },
          flow: 'y', gap: 'Y', padding: 'B', round: 'A', theme: 'card',
          AboutTitle: { tag: 'h3', text: '{{ about | polyglot }}', fontSize: 'A', fontWeight: '700' },
          AboutText: { text: (el, s) => { const e = el.call('getEntity'); return e ? (e.bioEn || e.descriptionEn || '') : '' }, fontSize: 'Z', lineHeight: '1.6', opacity: '0.8' },
          AboutTextKa: { text: (el, s) => { const e = el.call('getEntity'); return e ? (e.bioKa || e.descriptionKa || '') : '' }, fontSize: 'Z', lineHeight: '1.6', opacity: '0.5', marginTop: 'Y' }
        },

        // === LAWYER-ONLY SECTIONS ===
        EducationCard: {
          show: (el, s) => { const e = el.call('getEntity'); return !el.call('isFirmPage') && e && e.education && e.education.length > 0 },
          flow: 'y', gap: 'Z', padding: 'B', round: 'A', theme: 'card',
          EduTitle: { tag: 'h3', text: 'Education', fontSize: 'A', fontWeight: '700' },
          EduList: {
            flow: 'y', gap: 'Z',
            children: (el, s) => { const e = el.call('getEntity'); return e ? (e.education || []) : [] },
            childrenAs: 'state',
            childProps: {
              flow: 'y', gap: 'V', padding: 'Z 0', borderBottom: '1px solid surfaceBorderStrong',
              EduDegree: { text: (el, s) => s.degree || '', fontSize: 'Z', fontWeight: '600' },
              EduSchool: { text: (el, s) => s.institution || '', fontSize: 'Z', opacity: '0.7' },
              EduYear: { text: (el, s) => s.year || '', fontSize: 'Y', opacity: '0.5' }
            }
          }
        },

        ExperienceCard: {
          show: (el, s) => { const e = el.call('getEntity'); return !el.call('isFirmPage') && e && e.experience && e.experience.length > 0 },
          flow: 'y', gap: 'Z', padding: 'B', round: 'A', theme: 'card',
          ExpTitle: { tag: 'h3', text: 'Experience', fontSize: 'A', fontWeight: '700' },
          ExpList: {
            flow: 'y', gap: 'Z',
            children: (el, s) => { const e = el.call('getEntity'); return e ? (e.experience || []) : [] },
            childrenAs: 'state',
            childProps: {
              flow: 'y', gap: 'V', padding: 'Z 0', borderBottom: '1px solid surfaceBorderStrong',
              ExpRole: { text: (el, s) => s.role || '', fontSize: 'Z', fontWeight: '600' },
              ExpOrg: { text: (el, s) => s.organization || '', fontSize: 'Z', opacity: '0.7' },
              ExpPeriod: { text: (el, s) => s.period || '', fontSize: 'Y', opacity: '0.5' }
            }
          }
        },

        CertificationsCard: {
          show: (el, s) => { const e = el.call('getEntity'); return !el.call('isFirmPage') && e && e.certifications && e.certifications.length > 0 },
          flow: 'y', gap: 'Z', padding: 'B', round: 'A', theme: 'card',
          CertTitle: { tag: 'h3', text: 'Certifications', fontSize: 'A', fontWeight: '700' },
          CertList: {
            flow: 'y', gap: 'Y',
            children: (el, s) => { const e = el.call('getEntity'); return e ? (e.certifications || []).map(c => ({ label: typeof c === 'string' ? c : c.name })) : [] },
            childrenAs: 'state',
            childProps: {
              flow: 'x', gap: 'W', align: 'center flex-start',
              CertDot: { text: '\u2022', opacity: '0.4' },
              CertText: { text: (el, s) => s.label, fontSize: 'Z', opacity: '0.8' }
            }
          }
        },

        MembershipsCard: {
          show: (el, s) => { const e = el.call('getEntity'); return !el.call('isFirmPage') && e && e.memberships && e.memberships.length > 0 },
          flow: 'y', gap: 'Z', padding: 'B', round: 'A', theme: 'card',
          MemTitle: { tag: 'h3', text: 'Memberships', fontSize: 'A', fontWeight: '700' },
          MemList: {
            flow: 'y', gap: 'Y',
            children: (el, s) => { const e = el.call('getEntity'); return e ? (e.memberships || []).map(m => ({ label: typeof m === 'string' ? m : m.name })) : [] },
            childrenAs: 'state',
            childProps: {
              flow: 'x', gap: 'W', align: 'center flex-start',
              MemDot: { text: '\u2022', opacity: '0.4' },
              MemText: { text: (el, s) => s.label, fontSize: 'Z', opacity: '0.8' }
            }
          }
        },

        // === FIRM-ONLY: TEAM ===
        TeamSection: {
          show: (el, s) => el.call('isFirmPage'),
          flow: 'y', gap: 'A',
          TeamTitle: { tag: 'h3', text: '{{ ourTeam | polyglot }}', fontSize: 'B', fontWeight: '700' },
          TeamGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
            '@mobileL': { gridTemplateColumns: '1fr' },
            gap: 'A',
            children: (el, s) => {
              const e = el.call('getEntity')
              if (!e) return []
              return (s.root.lawyers || []).filter(l => l.firmId === e.id).map(l => ({ ...l, _type: 'lawyer' }))
            },
            childrenAs: 'state',
            childExtends: 'DirectoryCard'
          }
        },

        // Lawyer: GBA Link
        GbaLinkCard: {
          show: (el, s) => { const e = el.call('getEntity'); return !el.call('isFirmPage') && e && e.gbaProfileUrl },
          flow: 'x', gap: 'Z', padding: 'A', round: 'A', theme: 'card', align: 'center space-between',
          GbaLabel: { text: 'Georgian Bar Association Profile', fontSize: 'Z', opacity: '0.7' },
          GbaLink: {
            extends: 'Link',
            href: (el, s) => { const e = el.call('getEntity'); return e ? e.gbaProfileUrl : '#' },
            attr: { target: '_blank' },
            text: 'View on GBA \u2192', fontSize: 'Z', color: 'green', fontWeight: '500', textDecoration: 'none'
          }
        }
      },

      // === RIGHT COLUMN ===
      RightCol: {
        width: 'G1',
        flexShrink: '0',
        flow: 'y',
        gap: 'A',
        '@mobileL': { width: '100%' },

        // Actions (lawyer)
        ActionsCard: {
          show: (el, s) => !el.call('isFirmPage'),
          flow: 'y', gap: 'Z', padding: 'A', round: 'A', theme: 'card',
          BookBtn: {
            extends: 'Link', href: '/bookings/public',
            text: '{{ bookConsultation | polyglot }}',
            theme: 'primary', fontWeight: '600', padding: 'Z1 C', round: 'Z', fontSize: 'Z',
            width: '100%', textDecoration: 'none', textAlign: 'center', transition: 'all 0.2s ease', ':hover': { opacity: '0.9' }
          },
          MessageBtn: {
            show: (el, s) => { const e = el.call('getEntity'); return e && e.email },
            tag: 'button', text: '{{ sendMessage | polyglot }}', theme: 'ghost',
            fontWeight: '600', padding: 'Z1 C', round: 'Z', fontSize: 'Z', width: '100%', cursor: 'pointer', transition: 'all 0.2s ease'
          },
          CallBtn: {
            show: (el, s) => { const e = el.call('getEntity'); return e && e.phone },
            extends: 'Link',
            href: (el, s) => { const e = el.call('getEntity'); return e && e.phone ? 'tel:' + e.phone.replace(/\s/g, '') : '#' },
            text: (el, s) => { const e = el.call('getEntity'); return e && e.phone ? '{{ call | polyglot }} ' + e.phone : '' },
            theme: 'ghostTeal', fontWeight: '600', padding: 'Z1 C', round: 'Z', fontSize: 'Z',
            width: '100%', textDecoration: 'none', textAlign: 'center', transition: 'all 0.2s ease'
          }
        },

        // Contact (firm)
        ContactCard: {
          show: (el, s) => el.call('isFirmPage'),
          flow: 'y', gap: 'Z', padding: 'B', round: 'A', theme: 'card',
          ContactTitle: { tag: 'h3', text: '{{ contact | polyglot }}', fontSize: 'A', fontWeight: '700' },
          ContactPhone: {
            if: (el, s) => { const e = el.call('getEntity'); return e && e.phone },
            extends: 'Link',
            href: (el, s) => { const e = el.call('getEntity'); return e && e.phone ? 'tel:' + e.phone.replace(/\s/g, '') : '#' },
            text: (el, s) => { const e = el.call('getEntity'); return e ? e.phone : '' },
            fontSize: 'Z', color: 'green', fontWeight: '500', textDecoration: 'none'
          },
          ContactEmail: {
            if: (el, s) => { const e = el.call('getEntity'); return e && e.email },
            extends: 'Link',
            href: (el, s) => { const e = el.call('getEntity'); return e && e.email ? 'mailto:' + e.email : '#' },
            text: (el, s) => { const e = el.call('getEntity'); return e ? e.email : '' },
            fontSize: 'Z', color: 'green', fontWeight: '500', textDecoration: 'none'
          },
          ContactAddress: {
            text: (el, s) => { const e = el.call('getEntity'); return e ? e.address : '' },
            fontSize: 'Z', opacity: '0.6', lineHeight: '1.5'
          }
        },

        // Reviews (shared)
        ReviewsCard: {
          flow: 'y', gap: 'Z', padding: 'A', round: 'A', theme: 'card',
          ReviewTitle: { text: '{{ reviewsRatings | polyglot }}', fontSize: 'A', fontWeight: '700' },
          ReviewPlaceholder: { text: '{{ reviewsComingSoon | polyglot }}', fontSize: 'Z', opacity: '0.5', lineHeight: '1.5' }
        },

        // Links (lawyer)
        LinksCard: {
          show: (el, s) => { const e = el.call('getEntity'); return e && (e.website || e.linkedin || e.gbaProfileUrl) },
          flow: 'y', gap: 'Z', padding: 'A', round: 'A', theme: 'card',
          LinksTitle: { text: 'Links', fontSize: 'A', fontWeight: '700' },
          WebsiteLink: {
            show: (el, s) => { const e = el.call('getEntity'); return e && e.website },
            extends: 'Link', href: (el, s) => { const e = el.call('getEntity'); return e ? e.website : '#' },
            attr: { target: '_blank' }, flow: 'x', gap: 'W', align: 'center flex-start', textDecoration: 'none',
            WebIcon: { extends: 'Icon', icon: 'externalLink', width: 'Z', height: 'Z', opacity: '0.5' },
            WebLabel: { text: '{{ website | polyglot }}', fontSize: 'Z', color: 'green', fontWeight: '500' }
          },
          LinkedinLink: {
            show: (el, s) => { const e = el.call('getEntity'); return e && e.linkedin },
            extends: 'Link', href: (el, s) => { const e = el.call('getEntity'); return e ? e.linkedin : '#' },
            attr: { target: '_blank' }, flow: 'x', gap: 'W', align: 'center flex-start', textDecoration: 'none',
            LiIcon: { extends: 'Icon', icon: 'externalLink', width: 'Z', height: 'Z', opacity: '0.5' },
            LiLabel: { text: 'LinkedIn', fontSize: 'Z', color: 'green', fontWeight: '500' }
          },
          GbaLink2: {
            show: (el, s) => { const e = el.call('getEntity'); return !el.call('isFirmPage') && e && e.gbaProfileUrl },
            extends: 'Link', href: (el, s) => { const e = el.call('getEntity'); return e ? e.gbaProfileUrl : '#' },
            attr: { target: '_blank' }, flow: 'x', gap: 'W', align: 'center flex-start', textDecoration: 'none',
            GbaIcon: { extends: 'Icon', icon: 'externalLink', width: 'Z', height: 'Z', opacity: '0.5' },
            GbaLabel2: { text: 'GBA Profile', fontSize: 'Z', color: 'green', fontWeight: '500' }
          }
        }
      }
    }
  },

  FooterSection: {
    tag: 'footer', flow: 'y', gap: 'C', padding: 'D 0',
    borderTop: '1px solid surfaceBorderStrong', maxWidth: 'K', margin: '0 auto', width: '100%',
    '@mobileL': { padding: 'C A' },
    FooterTop: {
      flow: 'x', gap: 'C', '@mobileL': { flow: 'y', gap: 'B' },
      FooterBrand: {
        flow: 'y', gap: 'A', flex: '1.5', minWidth: 'F',
        FooterLogo: { extends: 'Link', href: '/', text: 'TrustLegal', fontSize: 'B', fontWeight: '800', color: 'green', textDecoration: 'none' },
        FooterTagline: { text: '{{ footerTagline | polyglot }}', fontSize: 'Z', color: 'textMuted', lineHeight: '1.6' }
      },
      FooterLinks: {
        flow: 'x', gap: 'C', flex: '2', '@mobileL': { flow: 'y', gap: 'B' },
        FooterCol1: {
          flow: 'y', gap: 'Z', flex: '1',
          ColTitle: { text: '{{ productLabel | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'textMuted', textTransform: 'uppercase', letterSpacing: '1px', padding: '0 0 Z 0' },
          ColLink1: { extends: 'Link', href: '/bookings', text: '{{ bookingsLink | polyglot }}', fontSize: 'Z', color: 'textMuted', textDecoration: 'none', ':hover': { color: 'text' } },
          ColLink2: { extends: 'Link', href: '/cases', text: '{{ casesLink | polyglot }}', fontSize: 'Z', color: 'textMuted', textDecoration: 'none', ':hover': { color: 'text' } },
          ColLink3: { extends: 'Link', href: '/lawyers', text: '{{ lawyersNav | polyglot }}', fontSize: 'Z', color: 'green', textDecoration: 'none', fontWeight: '500' }
        },
        FooterCol2: {
          flow: 'y', gap: 'Z', flex: '1',
          ColTitle: { text: '{{ companyLabel | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'textMuted', textTransform: 'uppercase', letterSpacing: '1px', padding: '0 0 Z 0' },
          ColLink1: { extends: 'Link', href: '/', text: '{{ aboutUs | polyglot }}', fontSize: 'Z', color: 'textMuted', textDecoration: 'none', ':hover': { color: 'text' } },
          ColLink2: { extends: 'Link', href: '/', text: '{{ careers | polyglot }}', fontSize: 'Z', color: 'textMuted', textDecoration: 'none', ':hover': { color: 'text' } }
        }
      }
    },
    FooterBottom: {
      flow: 'x', align: 'center space-between', padding: 'A 0 0 0', borderTop: '1px solid surfaceBorderStrong',
      '@mobileL': { flow: 'y', gap: 'Z', align: 'center center' },
      CopyText: { text: '{{ copyrightText | polyglot }}', fontSize: 'Z', color: 'textMuted' },
      BuiltWith: { text: '{{ builtWith | polyglot }}', fontSize: 'Z', color: 'textMuted' }
    }
  }
}
